import api from './api';

export const deliveryApi = {
  // Customer
  searchCustomer: (phone) => api.post('/api/delivery/customers/search', { phone }),
  createOrUpdateCustomer: (data) => api.post('/api/delivery/customers', data),
  
  // Google Places
  autocompleteAddress: (query) => api.get(`/api/delivery/places/autocomplete?query=${encodeURIComponent(query)}`),
  getPlaceDetails: (placeId) => api.get(`/api/delivery/places/details/${placeId}`),
  
  // Orders
  createDeliveryOrder: (data) => api.post('/api/delivery/orders', data),
  getDeliveryOrders: (status) => api.get(`/api/delivery/orders${status ? '?status_filter=' + status : ''}`),
  updateOrderStatus: (orderId, data) => api.patch(`/api/delivery/orders/${orderId}/status`, data),
  
  // Driver
  driverLogin: (credentials) => api.post('/api/delivery/driver/login', credentials),
  driverScan: (data) => api.post('/api/delivery/driver/scan', data),
  getDriverOrders: (driverId) => api.get(`/api/delivery/driver/${driverId}/orders`),
  optimizeRoute: (data) => api.post('/api/delivery/driver/optimize-route', data),
  
  // Seed
  seedDriver: () => api.post('/api/delivery/seed-driver'),
};
